import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb1yxpplfe5vmm as Char__compareTo_impl_ypi4mb,
  toString336ienavfnzn0 as toString,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.x4w_1 = 'Accept';
        this.y4w_1 = 'Accept-Charset';
        this.z4w_1 = 'Accept-Encoding';
        this.a4x_1 = 'Accept-Language';
        this.b4x_1 = 'Accept-Ranges';
        this.c4x_1 = 'Age';
        this.d4x_1 = 'Allow';
        this.e4x_1 = 'ALPN';
        this.f4x_1 = 'Authentication-Info';
        this.g4x_1 = 'Authorization';
        this.h4x_1 = 'Cache-Control';
        this.i4x_1 = 'Connection';
        this.j4x_1 = 'Content-Disposition';
        this.k4x_1 = 'Content-Encoding';
        this.l4x_1 = 'Content-Language';
        this.m4x_1 = 'Content-Length';
        this.n4x_1 = 'Content-Location';
        this.o4x_1 = 'Content-Range';
        this.p4x_1 = 'Content-Type';
        this.q4x_1 = 'Cookie';
        this.r4x_1 = 'DASL';
        this.s4x_1 = 'Date';
        this.t4x_1 = 'DAV';
        this.u4x_1 = 'Depth';
        this.v4x_1 = 'Destination';
        this.w4x_1 = 'ETag';
        this.x4x_1 = 'Expect';
        this.y4x_1 = 'Expires';
        this.z4x_1 = 'From';
        this.a4y_1 = 'Forwarded';
        this.b4y_1 = 'Host';
        this.c4y_1 = 'HTTP2-Settings';
        this.d4y_1 = 'If';
        this.e4y_1 = 'If-Match';
        this.f4y_1 = 'If-Modified-Since';
        this.g4y_1 = 'If-None-Match';
        this.h4y_1 = 'If-Range';
        this.i4y_1 = 'If-Schedule-Tag-Match';
        this.j4y_1 = 'If-Unmodified-Since';
        this.k4y_1 = 'Last-Modified';
        this.l4y_1 = 'Location';
        this.m4y_1 = 'Lock-Token';
        this.n4y_1 = 'Link';
        this.o4y_1 = 'Max-Forwards';
        this.p4y_1 = 'MIME-Version';
        this.q4y_1 = 'Ordering-Type';
        this.r4y_1 = 'Origin';
        this.s4y_1 = 'Overwrite';
        this.t4y_1 = 'Position';
        this.u4y_1 = 'Pragma';
        this.v4y_1 = 'Prefer';
        this.w4y_1 = 'Preference-Applied';
        this.x4y_1 = 'Proxy-Authenticate';
        this.y4y_1 = 'Proxy-Authentication-Info';
        this.z4y_1 = 'Proxy-Authorization';
        this.a4z_1 = 'Public-Key-Pins';
        this.b4z_1 = 'Public-Key-Pins-Report-Only';
        this.c4z_1 = 'Range';
        this.d4z_1 = 'Referer';
        this.e4z_1 = 'Retry-After';
        this.f4z_1 = 'Schedule-Reply';
        this.g4z_1 = 'Schedule-Tag';
        this.h4z_1 = 'Sec-WebSocket-Accept';
        this.i4z_1 = 'Sec-WebSocket-Extensions';
        this.j4z_1 = 'Sec-WebSocket-Key';
        this.k4z_1 = 'Sec-WebSocket-Protocol';
        this.l4z_1 = 'Sec-WebSocket-Version';
        this.m4z_1 = 'Server';
        this.n4z_1 = 'Set-Cookie';
        this.o4z_1 = 'SLUG';
        this.p4z_1 = 'Strict-Transport-Security';
        this.q4z_1 = 'TE';
        this.r4z_1 = 'Timeout';
        this.s4z_1 = 'Trailer';
        this.t4z_1 = 'Transfer-Encoding';
        this.u4z_1 = 'Upgrade';
        this.v4z_1 = 'User-Agent';
        this.w4z_1 = 'Vary';
        this.x4z_1 = 'Via';
        this.y4z_1 = 'Warning';
        this.z4z_1 = 'WWW-Authenticate';
        this.a50_1 = 'Access-Control-Allow-Origin';
        this.b50_1 = 'Access-Control-Allow-Methods';
        this.c50_1 = 'Access-Control-Allow-Credentials';
        this.d50_1 = 'Access-Control-Allow-Headers';
        this.e50_1 = 'Access-Control-Request-Method';
        this.f50_1 = 'Access-Control-Request-Headers';
        this.g50_1 = 'Access-Control-Expose-Headers';
        this.h50_1 = 'Access-Control-Max-Age';
        this.i50_1 = 'X-Http-Method-Override';
        this.j50_1 = 'X-Forwarded-Host';
        this.k50_1 = 'X-Forwarded-Server';
        this.l50_1 = 'X-Forwarded-Proto';
        this.m50_1 = 'X-Forwarded-For';
        this.n50_1 = 'X-Forwarded-Port';
        this.o50_1 = 'X-Request-ID';
        this.p50_1 = 'X-Correlation-ID';
        this.q50_1 = 'X-Total-Count';
        this.r50_1 = 'Last-Event-ID';
        this.s50_1 = 'TDM-Reservation';
        this.t50_1 = 'TDM-Policy';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u50_1 = ['Transfer-Encoding', 'Upgrade'];
        this.v50_1 = asList(this.u50_1);
      }
      w50(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
            throw IllegalHeaderNameException().h51(name, _unary__edvuaz);
          }
        }
      }
      x50(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().o51(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(header) {
        return new.target.t51(header);
      }
      static t51(header) {
        var $this = this.n2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.s51_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
function isDelimiter(ch) {
  return contains('"(),/:;<=>?@[\\]{}', ch);
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerName, position) {
        return new.target.h51(headerName, position);
      }
      static h51(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.g51_1);
        $this.e51_1 = headerName;
        $this.f51_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerValue, position) {
        return new.target.o51(headerValue, position);
      }
      static o51(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.n51_1);
        $this.l51_1 = headerValue;
        $this.m51_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance3m47m69p49qfb,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
